var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManOpenLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 251,
    viewBox: "0 0 185 251",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apqtij1k8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024 0v768H0V0h1024z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rsakcc2inb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.363 0 22.91 14.22h99.601l-1.025 203.13H27.8L5.385 234.777H0V0h4.363z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rv32asy8tc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.64 0v193.216H0V0h87.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qoplg3q4ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v181.813a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "udr0ozs1xe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.57 0a.769.769 0 0 1 0 1.537H.77A.77.77 0 1 1 .77 0h73.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svmdz5lkof"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19.117c.36.224.47.699.246 1.06L1.422 12.44a.77.77 0 0 1-1.306-.812L7.131.363A.769.769 0 0 1 8.19.117z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1z3jcingag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.722 0v251H0V0h184.722z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03pxe2qi3h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.633 0a.77.77 0 0 1 .77.77v202.952a.769.769 0 0 1-.77.768H.77a.769.769 0 0 1-.769-.768V.769A.77.77 0 0 1 .769 0h96.864zm-.768 1.537H1.538v201.415h95.327V1.537z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ggasiplgi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.408 0c.424 0 .769.344.769.769v193.215a.769.769 0 0 1-.769.768H.768a.769.769 0 0 1-.768-.768V.769C0 .344.344 0 .769 0h87.64zm-.77 1.538h-86.1v191.677h86.1V1.538z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3iebeootvj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.416.287a.77.77 0 0 1-.118 1.08L1.251 24.688a.766.766 0 0 1-1.081-.118.769.769 0 0 1 .118-1.081L29.335.168a.77.77 0 0 1 1.081.119z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y4pr0a4yak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.186.123 29.491 19.03a.769.769 0 1 1-.834 1.293L.353 1.415A.77.77 0 0 1 1.185.123z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "el0m55phrl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769V235.35a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "diai0n2ukm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.688 0c.425 0 .769.344.769.769v235.24a.769.769 0 0 1-.769.769H.768a.769.769 0 0 1-.768-.769V.77C0 .344.344 0 .769 0h4.92zM4.92 1.538H1.537v233.703H4.92V1.538z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xni19miqcn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.59 0a.769.769 0 0 1 0 1.537H.768A.769.769 0 0 1 .769 0h27.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7aaz5yy9co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v20.445a.769.769 0 0 1-1.537 0V.769C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kkjty1tkmp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v19.78a.769.769 0 0 1-1.537 0V.769C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d61yxph3tq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v20.67a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3yia9u9o2r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v19.89a.769.769 0 0 1-1.537 0V.768C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "le2n0ae8js"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.56 0a.769.769 0 0 1 0 1.537H.77A.769.769 0 0 1 .769 0H13.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pqvavdejut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.56 0a.769.769 0 0 1 0 1.537H.77A.769.769 0 0 1 .769 0H13.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mnu3n3y4du"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v18.758a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "773ydkw3mv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v15.18a.769.769 0 0 1-1.537 0V.769C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ik6apcrj0w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v19.649a.769.769 0 0 1-1.537 0V.768C0 .345.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u18q5trfqx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v15.345a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eees0gptcy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.769 0c.424 0 .768.344.768.769v181.813a.769.769 0 0 1-1.537 0V.77C0 .344.344 0 .769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c1pktavcz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.446.406 6.537 12.232a.768.768 0 0 1-1.355.725L.09 1.131A.769.769 0 1 1 1.446.406z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "71b4cami9A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.464 0v4.484H0V0h80.464z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zd1u7dl5bB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.232 0c.425 0 .77.344.77.769v4.484a.77.77 0 0 1-.77.769H.77A.769.769 0 0 1 0 5.252V.77C0 .344.344 0 .769 0h80.463zm-.768 1.537H1.537v2.947h78.927V1.537z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tyvuux4vcC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.34 0c.257 0 8.723 6.226 8.723 9.714v3.991l.001.855v1.762c.005 8.68.016 19.667.02 30.627V57.078c-.004 19.963-.047 37.332-.215 37.063-2.181.587-6.05 1.57-10.223 2.577l-.762.183c-.764.183-1.536.367-2.306.548l-.77.18C6.758 99.277.03 100.679.03 100.119.03 94.804.004 87.935 0 80.54v-3.36c.001-1.883.004-3.788.01-5.7l.008-2.299c.046-11.494.196-23.013.616-31.077.403-7.752.094-22.88 4.356-29.386 1.794-2.74 5.894-5.19 10.763-8.428l-.406.279C15.44.13 16.692.03 18.08.007l.42-.005.21-.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ewx532th0D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.11 0c.918 0 9.491 6.744 9.491 10.482v3.83l.001.68v2.112l.008 10.978c.005 7.502.011 15.775.012 23.869V59.95c-.002 4.197-.006 8.253-.012 12.024-.011 6.602-.03 12.329-.061 16.411-.049 6.243-.055 6.984-.493 7.197l-.053.023c-.045.017-.095.031-.15.047a.546.546 0 0 1-.09.02c-.75.198-6.856 1.802-13.222 3.305l-.85.2-.85.197c-5.382 1.244-10.625 2.32-12.662 2.32-.411 0-.69-.044-.815-.14a.914.914 0 0 1-.333-.667L.03 99.545c-.002-2.285-.007-4.82-.013-7.53-.007-3.29-.014-6.819-.016-10.467v-4.023c.008-13.868.12-28.81.634-38.692.066-1.261.112-2.72.163-4.305.268-8.372.634-19.838 4.318-25.463 1.637-2.501 4.908-4.65 9.048-7.37L15.522.8c.515-.758 2.08-.8 4.588-.8zm-.187 1.537c-.913 0-2.309.01-2.95.144l-.026.018-.324.215a.744.744 0 0 1-.175.116c-.489.324-.97.64-1.44.949-3.99 2.622-7.143 4.694-8.606 6.928-3.447 5.264-3.806 16.48-4.068 24.67-.05 1.596-.097 3.065-.163 4.336-.525 10.092-.63 25.504-.633 39.636v2.01c0 3.999.01 7.868.017 11.453.006 2.99.012 5.765.013 8.229 1.945-.13 8.415-1.542 14.834-3.065l.962-.229a466.789 466.789 0 0 0 10.56-2.642c.112-2.714.15-16.236.158-31.941l.001-1.633V58.26l.001-.83V47.368l-.001-.84v-1.674l-.001-.835v-1.663l-.01-14.274-.006-9.517v-1.46l-.001-.715v-1.397l-.001-.68-.001-3.224v-.607c0-2.687-6.783-8.116-8.14-8.945z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o6fsrex36E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.814 1.345a.77.77 0 0 1-1.335.762c-.239-.416-.537-.604-.914-.564-.534.05-1.234.568-1.535 1.455-1.305 3.844.174 10.103 1.414 13.145a.768.768 0 1 1-1.424.58C.697 13.476-.865 6.743.575 2.503 1.04 1.134 2.183.132 3.417.014c.989-.1 1.859.39 2.397 1.332z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "psfv0qrmrF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.19 0c.768 0 1.516.076 3.31.076.257 0 8.723 6.227 8.723 9.714v3.154l.001.837v1.728c.005 9.106.017 20.939.02 32.65V58.26c-.005 19.494-.05 36.221-.214 35.957-2.786.75-8.544 2.145-14.202 3.412l-.789.175C6.822 99.408 0 100.744 0 100.195c0-15.942.955-45.886 1.794-62.014.402-7.753.094-22.88 4.356-29.387 1.794-2.74 5.894-5.48 10.763-8.718z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de0kffy1tG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.958 0c.314 0 .624.012 1 .027.548.022 1.241.049 2.311.049.918 0 9.492 6.744 9.492 10.483l.001 3.83v2.076l.001.715v1.46l.007 9.517c.005 7.002.01 14.676.012 22.25v6.448c0 5.323-.004 10.482-.012 15.196-.01 6.6-.029 12.328-.06 16.41-.056 7.083-.056 7.083-.696 7.266a.757.757 0 0 1-.097.021c-1.528.391-23.841 6.026-28.72 6.026-.438 0-.735-.046-.864-.145a.912.912 0 0 1-.333-.666c0-15.766.948-45.764 1.795-62.054.065-1.262.112-2.72.162-4.305.268-8.372.634-19.838 4.319-25.463C8.17 6.247 12.38 3.447 17.256.205a.76.76 0 0 1 .363-.127.76.76 0 0 1 .339-.078zm.07 1.537c-4.7 3.127-8.753 5.83-10.466 8.446-3.447 5.264-3.805 16.48-4.067 24.67-.052 1.596-.099 3.065-.165 4.337-.834 16.05-1.767 45.426-1.792 61.33 1.94-.11 8.427-1.438 14.964-2.912l.98-.222.978-.223c4.064-.933 7.971-1.881 10.625-2.583.11-2.716.148-16.237.157-31.942v-1.632l.001-.822v-2.48l.001-.833V47.443l-.001-.84V44.93l-.001-.834V42.43l-.002-2.476-.001-1.635a82693.573 82693.573 0 0 0-.012-18.179l-.001-1.5-.001-2.175-.001-2.077v-3.83c0-2.688-6.785-8.118-8.142-8.946-.993-.003-1.655-.03-2.185-.05-.325-.012-.598-.024-.869-.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gy2h9nin3H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.449.339c.122-.569 2.258-.25 4.052-.25.257 0 8.723 6.227 8.723 9.714v3.991l.001.855.001 1.763c.004 8.68.015 19.666.018 30.627l.001 3.398V59.374c-.008 19.019-.054 35.115-.215 34.856-2.786.75-8.544 2.145-14.202 3.412l-.789.175C6.822 99.421 0 100.757 0 100.208c0-7.971.239-19.443.583-30.937l.07-2.298c.273-8.804.604-17.484.93-24.475l.085-1.784c.042-.872.084-1.713.126-2.52.402-7.753.094-22.88 4.356-29.387 1.794-2.74 5.895-5.48 10.763-8.718z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n1ip8hd79I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.789.041c.487.023.996.047 1.48.047.92 0 9.492 6.745 9.492 10.483v5.203l.001.704v1.44l.008 10.252c.004 6.002.009 12.497.011 19v3.249l.001 1.62v4.828c0 5.323-.004 10.483-.012 15.196-.01 6.6-.029 12.328-.061 16.41-.055 7.083-.055 7.083-.695 7.266a.756.756 0 0 1-.097.021c-1.528.392-23.841 6.025-28.72 6.027-.438 0-.735-.047-.864-.145a.91.91 0 0 1-.333-.666c0-7.754.23-18.95.563-30.265l.068-2.263c.335-10.94.76-21.782 1.164-29.526.065-1.262.112-2.72.162-4.305.268-8.373.634-19.839 4.319-25.464C8.078 6.4 11.979 3.73 16.554.684c.38-.776 1.602-.718 3.235-.643zm-1.76 1.508C13.328 4.676 9.274 7.381 7.562 9.996c-3.447 5.264-3.805 16.48-4.067 24.67-.052 1.596-.099 3.065-.165 4.336-.834 16.051-1.767 45.426-1.792 61.33 1.94-.11 8.427-1.437 14.964-2.91l.98-.223.978-.223c4.064-.933 7.971-1.882 10.625-2.584.11-2.716.148-16.237.157-31.942v-1.632l.001-.821v-2.482l.001-.832V47.455l-.001-.84v-1.673l-.001-.835v-1.664l-.002-2.476-.001-1.635a82691.547 82691.547 0 0 0-.012-18.178l-.001-1.5-.001-2.176-.001-2.077v-3.83c0-2.688-6.79-8.121-8.143-8.946-.45-.005-.916-.026-1.364-.048-.527-.024-1.26-.056-1.688-.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f4fh5a7xtJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.796 1.346a.77.77 0 0 1-1.335.763c-.238-.417-.537-.604-.914-.566-.534.052-1.233.568-1.534 1.457-1.218 3.587.11 10.171 1.537 13.546a.768.768 0 1 1-1.415.599C.669 13.682-.845 6.634.557 2.505 1.022 1.133 2.165.132 3.4.013c.99-.101 1.858.391 2.397 1.333z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k7klywjzxK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.913.338C17.035-.23 18.706.09 20.5.09c.256 0 8.722 6.226 8.722 9.713v3.154l.001.837v1.728c.005 8.518.015 19.423.02 30.382v12.369l-.001 2.194c-.008 18.538-.056 34.016-.214 33.762-2.203.593-6.263 1.59-10.664 2.607l-.78.18-.785.179-.788.18-.79.177C7.586 99.27 0 100.785 0 100.207c0-7.44.208-17.928.515-28.639l.102-3.447c.339-11.109.771-22.131 1.177-29.926.402-7.753.094-22.88 4.356-29.389 1.794-2.74 5.894-5.48 10.763-8.716z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "etgy3lbylL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.824.037c.45.024.943.05 1.445.05.919 0 9.492 6.743 9.492 10.48V15.772l.001.704v1.44l.008 10.252c.004 6.502.01 13.583.011 20.625v11.244c-.001 4.197-.005 8.253-.011 12.024-.01 6.6-.03 12.329-.061 16.41-.055 7.083-.055 7.083-.695 7.267a.771.771 0 0 1-.097.02c-.842.216-7.984 2.02-15.047 3.6l-.864.191c-5.465 1.208-10.726 2.235-12.809 2.236-.438 0-.735-.047-.864-.145a.91.91 0 0 1-.333-.666C0 85.209.948 55.21 1.795 38.92c.065-1.262.112-2.72.163-4.305.267-8.372.633-19.839 4.318-25.464 1.895-2.896 6.105-5.695 10.98-8.935a.755.755 0 0 1 .55-.12c.53-.137 1.245-.1 2.018-.059zm-1.52 1.517a.76.76 0 0 1-.748.308c-4.498 2.993-8.338 5.602-9.994 8.131-3.448 5.265-3.806 16.48-4.067 24.671-.052 1.596-.099 3.065-.165 4.336-.403 7.75-.829 18.603-1.164 29.548l-.07 2.345c-.322 10.942-.546 21.76-.557 29.436 1.94-.11 8.427-1.438 14.964-2.912l.98-.222c4.408-1.002 8.736-2.048 11.602-2.805.112-2.763.15-16.707.157-32.757v-1.639l.001-.824V47.452l-.001-2.513-.001-2.498v-1.654l-.009-12.619-.006-9.517-.001-1.46v-2.112l-.001-.681v-3.83c0-2.688-6.79-8.12-8.143-8.945-.466-.006-.92-.03-1.337-.05-.496-.027-1.15-.06-1.44-.019z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y8yzhinefM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.871.007c.446.036 1.527.293 1.919 1.9a.769.769 0 0 1-1.494.364c-.078-.32-.237-.707-.549-.732-.482-.055-1.199.52-1.606 1.48-1.4 3.303.018 8.83.623 11.19l.12.467a.768.768 0 1 1-1.492.374l-.117-.46C.576 11.868-.878 6.2.725 2.42 1.37.9 2.659-.094 3.872.006z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7g22d2lleN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.722 1.346a.77.77 0 0 1-1.335.763c-.238-.417-.537-.597-.915-.566-.534.052-1.232.568-1.534 1.457-1.06 3.121.27 7.898.984 10.465.123.445.232.835.313 1.158a.768.768 0 1 1-1.491.375c-.078-.312-.184-.69-.304-1.12C.628 10.959-.73 6.076.482 2.505.948 1.134 2.091.133 3.325.013c.985-.101 1.858.391 2.397 1.333z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aahl2bv5tO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.882 0C17.59.021 42.2 1.056 43.215 1.574c1.553.794 1.257 20.986.537 21.703-.62.62-5.815 1.527-6.692 1.437-2.954-.301-4.012-9.131-6.83-9.843-2.865-.724-7.762-1.147-8.222-4.353-.359-2.515-.086-4.514-3.594-4.671-.443-.02-.996-.03-1.635-.032h-.666c-3.463.005-8.854.137-13.112-.147l-2.05.43C.03 4.945-.578.218.85.11 1.76.04 3.223.005 5.069.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wpxixkbbpP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.16.466C15.29-1.58 31.38 3.708 33.37 4.812c3.786 2.101 4 8.6 4.007 13.023v.803l-.001.504c0 6.022.181 12.03.181 17.97 0 5.973.816 11.486.51 17.476-6.51.324-13.764.836-20.143.672-2.444-.063-2.68-2.149-2.614-4.315l.014-.372c.032-.744.086-1.484.086-2.142 0-4.995-.651-9.844-1.663-14.743-1.17-5.666-2.821-11.102-4.811-16.514-1.08-2.93-2.112-5.634-4.167-8.06C3.812 7.987-.366 5.913.026 4.254c2.83-.807 15 .797 14.526-3.98z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fqy9ovlhhQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.937.505C22.763.022 28.05-.15 33.03.144c.84 2.115-.408 3.6-.196 5.812-.545.222-1.264.361-2.019.505l-.456.087c-2.495.485-5.084 1.205-2.994 5.218 1.498 2.875 7.777.116 11.959 1.528 5.35 1.807 10.887 7.34 13.22 11.364 2.177 3.76 9.265 40.116 3.008 40.116-3.132 0-13.208-.155-23.718-.231l-1.215-.009-1.824-.011-.607-.003-1.213-.006c-1.613-.008-3.214-.012-4.777-.013h-1.165c-5.788.003-10.97.059-14.297.212-1.364.207-5.478.349-5.963.027-.55-.363-.76-3.009-.772-6.625v-.736c.007-2.243.082-4.805.194-7.4l.039-.867c.279-6.067.739-12.15.989-14.65.56-5.613.538-12.776 1.168-18.239.18-1.557.31-2.605.432-3.643l.039-.328c.231-1.974.455-4.1.966-9.775l.047-.595C7.17 1.164 14.785.82 17.937.505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ryk9devlbR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.783 0C41.87.795 42.326 1.875 42.57 2.456c.1.237.073.524-.07.739l-.023.033c-.267.392-.618.548-9.872.56l-.792.001c-3.252.002-7.52-.013-13.132-.039l-1.198-.005-.798-.003c-2.656-.012-5.271-.022-7.556-.024h-1.96c-2.885.004-4.952.029-5.41.092a.768.768 0 1 1-.21-1.523c.542-.076 2.598-.105 5.96-.108H8.83c2.65.002 5.96.016 9.857.035 2.15.009 4.483.02 6.813.027C17.498 1.93 8.006 1.678.754 1.538A.77.77 0 0 1 0 .754C.008.33.4.018.783 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hxt7kgxthS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.036 0c3.022 0 4.64 1.407 4.813 4.184.086 1.454-1.22 2.99-2.913 3.427-2.644.685-6.49.835-9.355.835-2.134 0-3.725-.084-3.875-.091-.743.028-2.202.072-3.749.07l-.666-.005c-.89-.01-1.78-.037-2.553-.094C2.064 8.129.478 7.296.149 5.912-.165 4.58.018 3.442.696 2.53 1.727 1.14 3.862.366 7.22.158L23.009 0h.027zm.005 1.538h-.023l-15.743.157c-2.8.173-4.61.762-5.345 1.752-.4.538-.493 1.229-.284 2.11.146.619 1.404 1.103 3.204 1.235 2.243.165 5.552.073 6.87.026.063.003 1.499.078 3.474.086h.526c2.78-.005 6.405-.153 8.83-.782 1.144-.295 1.798-1.273 1.764-1.845-.09-1.423-.549-2.739-3.273-2.739z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m5ror0ohbT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.523.001a.77.77 0 0 1 .71.824C4.986 4.1 4.6 7.944 4.152 12.395 2.75 26.321.832 45.392 1.8 63.195a.769.769 0 0 1-.726.81l-.042.001a.769.769 0 0 1-.767-.727c-.974-17.922.951-37.062 2.356-51.038C3.07 7.8 3.455 3.966 3.7.709a.778.778 0 0 1 .824-.708z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hi5b10i40U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.847.691c.476 4.7 1.085 17.994 1.512 31.23l.05 1.587c.395 12.69.61 25.008.363 29.303a.77.77 0 0 1-.734.724c-6.543.288-24.024.522-40.624.694l-1.578.016c-9.185.093-17.982.168-24.364.222-4.695.04-8.176.068-9.694.088h-.01a.77.77 0 0 1-.009-1.538c1.519-.019 5.002-.048 9.7-.088 7.135-.06 17.289-.146 27.626-.255l1.551-.017c15.005-.162 30.098-.374 36.633-.629.18-4.629-.03-16.069-.394-27.937l-.049-1.55C75.4 19.096 74.784 5.458 74.317.846a.768.768 0 1 1 1.53-.155z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1oij8ly1hV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.476.37a.769.769 0 0 1-.912 1.19c-.404-.052-1.865 0-2.506.021a53.75 53.75 0 0 1-.724.023c-7.467.132-12.866.395-16.747.688 1.28.005 2.622.009 3.982.01h3.185l.906-.002c5.415-.013 10.444-.062 12.36-.158a.761.761 0 0 1 .806.73.768.768 0 0 1-.729.805c-2 .1-8.011.154-14.175.162h-.86l-.431.001h-1.955C7.227 3.83 1.367 3.773.653 3.666a.77.77 0 0 1-.21-1.457c.014-.007.058-.026.143-.056l.138-.047c.233-.074.63-.184 1.267-.315l.234-.048C5.003 1.2 11.755.34 27.306.067c.169-.004.414-.013.698-.022A66.063 66.063 0 0 1 29.75 0h.31c.956.011 1.201.112 1.416.37z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2fpevrv2dW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.223.001c.44-.025.787.3.812.725a.77.77 0 0 1-.725.81c-.492.03-1.517 1.03-2.218 1.994-1.238 6.188-.053 8.472.28 8.964 4.71 1.52 32.403.837 34.983-.874.32-1.497.335-4.93-.092-6.158-.317-.908-.98-1.793-1.92-2.557a.77.77 0 0 1 .971-1.193c1.16.945 1.99 2.066 2.4 3.244.59 1.691.478 5.673.098 7.184-.129.516-.612.765-.771.847-1.866.965-9.882 1.617-17.977 1.81l-.9.019c-1.348.026-2.693.04-4.005.04-6.247 0-11.766-.308-13.53-.994a.786.786 0 0 1-.247-.156l-.05-.05C.926 13.227-.956 10.758.618 3.062c.02-.102.063-.2.123-.285C1.053 2.329 2.69.088 4.223 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jzzbj6nptX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.112 2a.767.767 0 0 1-.739-.797c.015-.425.365-.797.797-.738 3.7.136 4.68 2.377 4.72 2.473.7 2.22 1.4 8.541-.972 10.684-1.601 1.446-13.479 1.822-22.797 1.822-4.448 0-8.312-.086-10.199-.182a55.027 55.027 0 0 0-1.065-.04c-1.754-.056-3.936-.126-5.34-.684-.113-.04-3.243-1.22-3.457-4.198C.01 9.516-.374 2.29 1.69.225a.769.769 0 1 1 1.088 1.087c-1.19 1.19-1.357 6.106-1.184 8.926.142 1.971 2.45 2.856 2.474 2.865 1.171.464 3.291.532 4.838.582.399.012.77.025 1.095.041 2.577.132 5.84.2 9.29.206h.866c.58 0 1.164-.003 1.75-.007l1.32-.012 1.32-.018c8.346-.132 16.35-.61 17.343-1.416 1.506-1.361 1.302-6.388.618-8.808l-.062-.205c-.007 0-.688-1.367-3.334-1.466z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qov65gyzkY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.124.098c3.874 2.152 4.088 7.85 4 10.202-.005.158-.008.333-.012.515-.016 1.085-.036 2.435-.68 3.32a2.123 2.123 0 0 1-.017.024l-.018.024a.59.59 0 0 1-.01.012l-.022.024a.488.488 0 0 1-.013.012l-.028.025c-.455.376-2.636.876-21.041 1.222-3.437.065-7.96.132-11.96.132-4.122 0-7.686-.071-8.93-.289-.57.067-3.491.325-5.178-1.071-.752-.622-1.16-1.461-1.211-2.497A39.803 39.803 0 0 1 0 11.368v-.47C.01 8.795.14 3.723 1.149 1.82a.768.768 0 1 1 1.359.719c-.87 1.644-.993 7.174-.967 9.165.029.566.242 1.02.652 1.36 1.09.904 3.317.829 4.083.722a.788.788 0 0 1 .418.06c.629.156 3.458.225 7.359.23h.918a663.4 663.4 0 0 0 11.162-.125l1.133-.022 1.698-.036c8.658-.192 16.854-.51 18.324-.828.263-.548.278-1.534.29-2.273.002-.195.004-.379.011-.549.077-2.068-.082-7.063-3.211-8.802a.768.768 0 1 1 .747-1.343z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kt4a4swruZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.691.39c3.229.565 4.935 5.107 5.386 7.431.245 1.254.21 3.051.198 3.492.065.376-.032.747-.275 1.06-1.248 1.603-7.539 1.607-9.437 1.573-1.17.033-2.981.047-5.039.048h-.415c-1.26 0-2.603-.004-3.94-.01l-.728-.005a842.502 842.502 0 0 1-9.296-.097.77.77 0 0 1-.752-.786c.01-.424.375-.736.786-.752 1.028.023 5.015.072 9.225.097l.845.005c.986.005 1.975.009 2.932.01h1.601c1.946-.002 3.651-.016 4.775-.047 3.833.083 7.566-.359 8.184-.93a.761.761 0 0 1-.005-.126c0-.02.073-2.005-.168-3.239-.427-2.196-1.927-5.822-4.14-6.207-4.005-.698-16.604-.19-16.73-.184-2.858-.156-8.515.318-9.626 1.097-.255.177-.346.268-.568.993a.766.766 0 0 1-.96.51.767.767 0 0 1-.51-.96C.302 2.487.533 2.019 1.19 1.56 3 .289 9.796.085 11.709.187c.243-.011 3.956-.162 7.978-.184L20.399 0h.715c2.979.009 5.923.104 7.577.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1pi0m8bmaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.995.034c.782.136 7.517.231 14.16.284l.796.006c2.385.017 4.726.03 6.742.036a.768.768 0 0 1-.002 1.537C8.489 1.852 1.012 1.71.466 1.476A.77.77 0 0 1 .995.034z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lsj0mfj6hab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.782.258c2.342 2.634 3.017 5.245 3.045 5.354a.775.775 0 0 1 .024.188c0 1.604-.432 2.823-1.283 3.623a3.425 3.425 0 0 1-2.298.92c-.163 0-.168-.002-.238-.002l-.418-.001c-.702-.003-1.827-.01-3.204-.02-2.138-.013-4.91-.032-7.745-.044l-.897-.004c-1.345-.005-2.691-.008-3.976-.01H7.53c-3.025.003-5.564.024-6.724.079-.421.042-.784-.306-.805-.73a.769.769 0 0 1 .73-.805c1.178-.057 3.731-.08 6.768-.082h1.268c4.298.002 9.27.036 12.653.06 1.714.01 3.034.02 3.676.02h.172c.194-.004.777-.05 1.262-.517.503-.485.767-1.286.782-2.385-.132-.443-.825-2.536-2.679-4.623a.769.769 0 0 1 1.15-1.021z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6xoayb3v1ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.48 0a.768.768 0 0 1 .003 1.537c-1.681.007-6.065.052-10.79.098l-2.473.025-.83.008c-4.697.047-9.287.09-11.294.095H.769a.769.769 0 0 1 0-1.537c1.738 0 6.37-.043 11.194-.09l.828-.009.415-.004.828-.008 1.642-.017C20.264.052 24.528.01 26.316 0L26.48 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bec424drzad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.129.133 2.506.043.84.014c3.217.055 6.355.102 8.49.106h.534c.595-.001 1.09-.007 1.458-.018h.022A.769.769 0 0 1 24 1.815a64.06 64.06 0 0 1-1.733.018c-2.182 0-5.526-.05-8.942-.107l-1.08-.019-2.144-.037c-3.854-.068-7.495-.132-9.333-.132A.769.769 0 0 1 .769 0c1.852 0 5.5.065 9.36.133z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wlcl82zilae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.499.438 25.25 4.12c.319.965.298 1.677-.022 2.214a1.51 1.51 0 0 1-.985.715c-.969.06-4.193.08-8.007.083h-2.615c-3.18-.003-6.5-.014-9.124-.022l-2.703-.009h-.398l-.18-.001H.77a.769.769 0 1 1 0-1.538h.628l3.107.01c1.837.006 4.144.014 6.528.019l.844.001 2.113.003h2.87c3.301-.003 6.07-.02 7.058-.063.032-.07.078-.32-.092-.845l-1.715-3.59A.77.77 0 0 1 23.5.439z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gv946uko1af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.916.015.793.004.398.002.796.004c1.99.01 3.958.022 5.686.032 2.446.014 4.4.026 5.232.026a.769.769 0 0 1 0 1.538h-.268c-.942-.003-2.757-.014-4.973-.026-3.793-.023-8.75-.052-12.52-.056H4.436c-1.729.002-3.05.012-3.639.034-.403.048-.78-.315-.796-.74A.767.767 0 0 1 .739.038 119.96 119.96 0 0 1 4.103 0h2.28c1.402.002 2.95.007 4.533.014z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g6cr7yxw7ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.027 2.281c.072.05.132.11.18.178.022.016.042.034.062.054 1.128 1.104 1.933 3.702 1.723 5.56-.14 1.246-.69 1.826-1.128 2.093-.787.48-1.964.644-3.318.644-1.243 0-2.637-.138-4.017-.295-.31-.036-.59-.068-.83-.092-1.675-.167-3.907-.7-5.024-2.292C-.007 7.16-.173 5.96.18 4.562.7 2.51 1.918 1.075 3.704.414c3.004-1.113 6.939.19 9.323 1.867zm-6.845-.745c-.689 0-1.349.1-1.944.32C2.93 2.34 2.066 3.377 1.67 4.939c-.242.957-.156 1.712.262 2.31.611.869 2.003 1.453 3.919 1.645.245.024.534.057.85.093 1.81.206 5.173.59 6.36-.133.201-.123.348-.47.402-.953.157-1.384-.473-3.509-1.27-4.29a.82.82 0 0 1-.083-.095c-1.595-1.114-3.887-1.98-5.929-1.98z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aduxxvz90ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.548 3.275a.77.77 0 0 1-.626.889.773.773 0 0 1-.888-.627c-.257-1.47-2.495-2.175-6.289-1.963-.788.041-3.182.169-3.208 4.24A.769.769 0 0 1 0 5.804C.022 2.244 1.678.197 4.663.038c4.82-.261 7.466.83 7.885 3.237z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mybpzf23zai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.894.84A.769.769 0 1 1 9.41 2.3c-1.375-.453-4.77-1.38-6.6-.167-.748.495-1.157 1.308-1.254 2.485-.085 1.028.102 1.74.553 2.117 1.11.93 3.923.177 5.785-.32l.25-.066a.768.768 0 1 1 .396 1.485l-.25.066c-1.363.365-3.026.81-4.513.81-1.018 0-1.954-.21-2.654-.794-.858-.717-1.227-1.87-1.1-3.424C.16 2.838.812 1.613 1.963.852 4.265-.676 7.92.19 9.894.84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pbempasb6aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.377 2.048a.768.768 0 0 1-1.174.993c-1.46-1.725-2.922-1.957-4.739-.755-2.5 1.658-3.786 3.484-3.928 5.583a.768.768 0 1 1-1.534-.104c.174-2.573 1.726-4.847 4.614-6.76C7.079-.627 9.418-.266 11.377 2.048z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o2rvc2l5sak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.718 0 .251 18.33-36.717.503L0 .503 36.718 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e2ekblkjpal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.635 0C4.501-.01 5.24.193 5.857.616c.614.424 1.084 1.014 1.41 1.777.322.76.491 1.654.506 2.68l.109 8.049c.016 1.011-.13 1.905-.433 2.68-.305.778-.762 1.387-1.368 1.826-.61.44-1.342.665-2.196.679l-3.634.048L0 .05 3.635 0zm.064 3.388-.564.008.158 11.527.565-.007c.577-.007.858-.495.846-1.462l-.117-8.628c-.015-.966-.31-1.445-.888-1.438z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vbhpatb4gam"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.552 0 .25 18.304-2.768.037L2.996 8.47l-.17.002.456 9.893-3.033.042L0 .102 2.694.066 4.81 10.139l.17-.003L4.502.04 7.552 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8hjyjjpslan"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.518 0 .043 3.21-2.372.035.057 4.124 2.185-.03.043 3.21-2.185.03.062 4.549 2.487-.034.043 3.21-5.631.077L0 .076 5.518 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l8hhd1rn2ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.72 0 .251 18.33-36.719.502L0 .502 36.72 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mbrxcdf49ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64 0a3.371 3.371 0 0 1 3.42 3.33l.159 11.518a3.372 3.372 0 0 1-3.328 3.42L3.58 18.3a3.378 3.378 0 0 1-3.421-3.33L0 3.453A3.377 3.377 0 0 1 3.33.033zm.043 3.013-2.312.032a.36.36 0 0 0-.356.367l.158 11.517c.003.2.167.36.366.359l2.31-.034c.2-.002.36-.166.357-.366L6.048 3.369a.36.36 0 0 0-.365-.356z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ws733peltaq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.72 0 .251 18.33-36.719.502L36.72 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zb80hq1xhar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.365 0a.839.839 0 0 1 .848.827l.02 1.537a.838.838 0 0 1-.825.85l-1.54.02a.838.838 0 0 1-.847-.826L0 .87A.84.84 0 0 1 .825.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "22haw50baas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.891 5.502-.081-.75C1.036 4.34.367 2.105.114 1.264L.032.989A.768.768 0 1 1 1.506.551l.08.271c.642 2.137 1.08 3.849.441 4.822a1.425 1.425 0 0 1-1.134.641.769.769 0 0 1-.089-1.532l.087.749z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o45c9rg8nat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41.345c.027.04 2.506 4.158 1.506 5.788-.159.26-.526.668-1.267.668-.079 0-.163-.005-.251-.015a.768.768 0 0 1-.677-.85.76.76 0 0 1 .851-.677l.055.003C1.785 4.56.652 1.986.128 1.193A.767.767 0 0 1 .345.128.766.766 0 0 1 1.41.345z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n8c2p1zu2au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.078 0c.586.337 1.756 3.883 1.459 5.308-.164.78-.68 1.275-1.418 1.356A.768.768 0 0 1 .95 5.136c.031-.004.043-.009.043-.009C1.283 4.783.79 2.692 0 .994L.696.671 1.078 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nsckvpvyyav"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82 1.528c.972.961 2.238 4.681 1.032 5.764-1.245 1.121-5.174.05-6.294-.817C1.666 5.785-1.41 1.451.76 1.22L2.199.141c1.285-.476 4.537.32 5.621 1.387z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qqpb5dx73aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.836 1.479c1.1.937 1.904 3.297 1.796 5.259-.07 1.243-.5 2.167-1.245 2.673a.767.767 0 0 1-.348.127c-.719.359-1.935.526-3.858.526-1.232 0-2.754-.069-4.621-.2-.337-.022-.609-.04-.79-.05-.234-.011-.479-.02-.727-.027-1.637-.05-3.491-.108-4.46-1.298-.527-.647-.698-1.525-.508-2.61C.86 1.394 3.265.306 5.146.184l.568-.039c2.783-.193 6.991-.484 9.122 1.335zM8.93 1.54c-1.123 0-2.226.076-3.11.136l-.573.04C3.31 1.843 2.08 3.332 1.59 6.145c-.11.626-.048 1.087.185 1.373.433.532 1.514.657 2.613.707l.47.018.233.007c.257.008.51.016.755.028.19.01.47.03.82.054 6.087.424 7.479.041 7.767-.223a.696.696 0 0 1 .444-.423c.121-.265.196-.616.22-1.033.087-1.576-.605-3.447-1.259-4.006-1.04-.886-3.003-1.106-4.909-1.106z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47xxi7h44ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.554.143c.344.249.423.73.175 1.073-.632.88-1.128 1.673-1.652 2.512-.214.341-.43.688-.661 1.048a.768.768 0 1 1-1.294-.829c.227-.355.44-.698.65-1.034.54-.86 1.047-1.673 1.71-2.593A.77.77 0 0 1 3.553.143z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xado5yl24ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.087.069c.957.435 1.695 1.65 2.346 2.722.17.282.335.553.49.785a.768.768 0 1 1-1.277.855c-.167-.25-.343-.54-.527-.842C1.636 2.794.976 1.708.45 1.469a.768.768 0 1 1 .636-1.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "otskxoof3az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.481.006a.77.77 0 0 1 .65.873c-.342 2.322-1.117 7.606-1.887 13.013l-.231 1.623c-.587 4.142-1.146 8.19-1.481 10.864a.768.768 0 1 1-1.526-.19c.336-2.681.896-6.735 1.484-10.883l.153-1.083.155-1.083C2.543 7.92 3.278 2.902 3.608.655c.062-.421.453-.7.873-.649z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "169ig0emeaA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53.656c1.076 7.365 1.788 15.02 2.308 20.609.172 1.849.318 3.431.447 4.64a.77.77 0 0 1-1.53.162c-.128-1.215-.276-2.803-.449-4.66C1.788 15.835 1.08 8.203.008.879A.769.769 0 0 1 1.53.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kopiso6nraB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.013 0c.816 6.253 6.23 7.61 6.602 7.695l.02.005c-5.948 1.51-6.78 8.023-6.78 8.023C6.148 9.21 0 7.812 0 7.812 6.15 6.819 7.013 0 7.013 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saf9iuoysaC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78 0c.386 0 .713.286.763.67.765 5.868 5.966 7.035 6.018 7.047a.768.768 0 0 1 .03 1.496c-5.355 1.36-6.175 7.133-6.207 7.378a.77.77 0 0 1-1.527-.016C6.222 10.705.825 9.383.596 9.33A.768.768 0 0 1 .645 7.82C6.162 6.931 7.009.735 7.018.671A.769.769 0 0 1 7.778 0zm-.04 3.612C6.998 5.38 5.61 7.552 3.084 8.69c1.535.812 3.513 2.302 4.589 4.884.735-1.74 2.099-3.87 4.588-5.125-1.482-.768-3.43-2.22-4.52-4.836z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5nktqjvpaD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.012 0c.845 6.476 6.621 7.698 6.621 7.698-5.948 1.51-6.78 8.025-6.78 8.025C6.148 9.209 0 7.81 0 7.81 6.148 6.817 7.012 0 7.012 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2bdo0ys7iaE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78 0c.386 0 .712.285.762.669a8.12 8.12 0 0 0 6.02 7.046.77.77 0 0 1 .029 1.497c-5.379 1.366-6.2 7.316-6.207 7.377a.77.77 0 0 1-1.527-.016C6.22 10.703.825 9.382.596 9.328a.77.77 0 0 1 .05-1.508C6.139 6.933 6.984.926 7.018.67A.769.769 0 0 1 7.78 0zm-.04 3.612C6.997 5.38 5.609 7.551 3.083 8.688c1.534.812 3.512 2.303 4.588 4.883.736-1.74 2.1-3.868 4.588-5.124-1.481-.767-3.429-2.22-4.52-4.835z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "we7z7ozukaF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.267 0C5.9 4.864 10.24 5.782 10.24 5.782c-4.467 1.135-5.094 6.026-5.094 6.026C4.618 6.917 0 5.866 0 5.866 4.618 5.12 5.267 0 5.267 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hyfof54ttaG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.035 0c.386 0 .712.285.762.668a5.917 5.917 0 0 0 4.374 5.13.769.769 0 0 1 .027 1.496c-3.893.99-4.496 5.203-4.52 5.382a.77.77 0 0 1-1.527-.017C4.69 8.391.761 7.421.594 7.383a.77.77 0 0 1 .05-1.509C4.627 5.231 5.249.855 5.273.67A.77.77 0 0 1 6.035 0zm-.02 3.391c-.61 1.257-1.602 2.546-3.102 3.334 1.044.608 2.265 1.61 3.04 3.195.562-1.178 1.5-2.506 3.046-3.387-1.008-.58-2.204-1.555-2.984-3.142z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7dsrv0xxyaH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.267 0C5.9 4.864 10.24 5.782 10.24 5.782c-4.467 1.135-5.094 6.026-5.094 6.026C4.618 6.917 0 5.866 0 5.866 4.618 5.12 5.267 0 5.267 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clx4x85v8aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.035 0c.386 0 .712.285.762.669a5.914 5.914 0 0 0 4.374 5.129.772.772 0 0 1 .605.739.767.767 0 0 1-.579.757c-3.892.99-4.495 5.204-4.52 5.382a.77.77 0 0 1-1.526-.016C4.69 8.39.761 7.42.594 7.383a.769.769 0 0 1 .05-1.508C4.627 5.233 5.249.855 5.273.67A.77.77 0 0 1 6.035 0zm-.02 3.392c-.61 1.257-1.602 2.545-3.102 3.333 1.044.61 2.265 1.61 3.04 3.195.562-1.177 1.5-2.504 3.046-3.387-1.008-.58-2.204-1.555-2.984-3.141z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xjqrw9iplaJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.031 22.242-.002-.138C5.97 19.165 5.263 12.35 0 11.836c0 0 6.244-.642 6.435-11.441L6.44 0s.46 10.85 5.72 11.836c0 0-5.626-.816-6.115 10.046l-.014.36z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tdhj8n1w9aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.194.001c.386-.025.765.318.783.736.122 2.848 1.276 10.397 5.092 11.113a.768.768 0 0 1-.252 1.517c-.04-.006-1.246-.14-2.486.958-1.178 1.043-2.565 3.38-2.76 8.608l.002.18v.326a14.85 14.85 0 0 1-.026.818.769.769 0 0 1-.766.719l-.026-.001a.768.768 0 0 1-.744-.768c0-.394.006-.778.018-1.154-.037-2.657-.61-9.22-5.335-9.682a.769.769 0 0 1-.004-1.53c.228-.027 5.71-.798 5.75-11.075a.768.768 0 0 1 .754-.765zm.116 6.353c-.943 3.514-2.71 5.274-4.16 6.153 1.937 1.01 3.036 2.977 3.653 5.017.56-1.933 1.415-3.403 2.56-4.395a5.55 5.55 0 0 1 1.218-.806C8.909 10.97 7.908 8.597 7.31 6.354z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saptvqeuqaL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.744.092a.77.77 0 0 1 .315 1.04l-.281.524C4.393 4.234 3.299 6.27 2.897 9.243c-.404 2.982-1.36 12.538-1.36 16.468a.769.769 0 0 1-1.537 0C0 21.43 1.02 11.645 1.373 9.037c.44-3.25 1.592-5.394 3.05-8.109l.28-.521a.767.767 0 0 1 1.04-.315z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "swr79n6bqaM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12.32a.768.768 0 0 1-.176 1.072c-3.54 2.545-5.509 11.936-5.403 25.764a.769.769 0 0 1-1.537.013L0 26.432v-.766C.035 17.1.947 3.81 6.048.144A.77.77 0 0 1 7.121.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ubi8unl5naN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6.188c.32.28.355.765.076 1.085-5.233 6.026-5.232 19.425-5.108 23.389a.767.767 0 0 1-.745.792H.8a.77.77 0 0 1-.768-.745C-.098 20.606-.084 6.713 5.515.265A.768.768 0 0 1 6.6.188z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o6g8av41maO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.394.206c.31.29.327.776.037 1.087C3.164 3.72 2.359 5.266 1.517 8.804A.769.769 0 1 1 .02 8.448C.917 4.686 1.88 2.845 4.308.243A.77.77 0 0 1 5.394.206z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crsr4pvx1aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.457 0a.769.769 0 0 1 .764.773c-.007 1.047-.148 3.362-.297 5.813L1.852 7.76l-.047.793c-.142 2.377-.268 4.718-.268 6.025a.769.769 0 0 1-1.537 0c0-1.717.207-5.101.389-8.087C.537 4.063.678 1.77.683.764A.759.759 0 0 1 1.457 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lg9pbwu0yaQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.197 18.448c-.366-.057-9.071-1.248-9.781 15.497l-.016.407v-.053C9.33 29.901 8.298 19.262 0 18.45l.103-.014.078-.013C1.531 18.18 9.975 16.03 10.038 0c0 0 .945 16.526 8.887 18.391l.272.057z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rs88gvngmaR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.786.001c.403-.026.764.31.788.725.01.163 1.027 16.33 8.541 17.738a.769.769 0 0 1-.275 1.512c-.087-.012-2.245-.344-4.419 1.502-1.912 1.625-4.166 5.279-4.477 13.498a26.699 26.699 0 0 1-.038 2.026.77.77 0 0 1-.767.718h-.025a.769.769 0 0 1-.744-.768c0-.597.009-1.18.027-1.747-.06-4.139-.988-14.465-8.703-15.22a.769.769 0 0 1-.004-1.53c.375-.042 9.284-1.237 9.348-17.688A.768.768 0 0 1 10.786 0zm.212 7.386C9.618 14.755 6.06 17.83 3.545 19.101c3.884 1.564 5.751 5.499 6.635 9.284.817-3.69 2.25-6.406 4.289-8.115a8.022 8.022 0 0 1 2.576-1.466c-3.357-2.31-5.126-7.28-6.047-11.417z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v05jtcp0gaS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.822 0s1.548 16.913 9.747 18.45c0 0-9.858 1.358-10.415 17.732v-.087C10.138 34.83 9.76 20.077 0 18.45c0 0 10.711-2.229 10.822-18.45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bz7lz27qeaT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.356.701c.015.163 1.59 16.352 9.124 17.764a.77.77 0 0 1-.036 1.518l-.014.002-.042.007c-.842.147-9.186 1.986-9.697 16.987a.768.768 0 0 1-.768.743h-.014a.769.769 0 0 1-.755-.771v-.066c-.015-1.1-.396-15.386-9.51-16.905a.77.77 0 0 1-.031-1.511c.41-.088 10.105-2.347 10.209-17.703a.768.768 0 0 1 .736-.763c.4-.04.76.29.798.698zm-.554 5.88c-1.01 5.084-3.212 8.21-5.131 10.053a14.388 14.388 0 0 1-3.484 2.481c4.727 1.967 6.827 7.13 7.76 11.402C12.627 23.248 16.51 20.33 19 19.18c-4.03-2.238-6.14-8.097-7.198-12.599z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rec80p8miaU"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.863.002a.768.768 0 0 1 .703.83c-.145 1.723.253 3.05 1.216 4.055 2.71 2.827 9.468 2.55 13.942 2.369a71.829 71.829 0 0 1 2.782-.082.769.769 0 0 1 0 1.538c-.775 0-1.702.038-2.72.08-1.297.052-2.717.11-4.164.11-4.174 0-8.583-.48-10.95-2.952C.403 4.627-.149 2.863.032.703a.774.774 0 0 1 .83-.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "no6y4hae4aV"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.579 11.419.113.542.333 1.62.112.533c.301 1.42.624 2.789 1.048 4.022 5.717-2.537 8.935 4.417 8.79 8.947-.149 4.74 5.55 20.984 15.828 22.735.311 5.505 2.35 11.927 2.382 17.417-7.286.37-14.39.891-21.79.525-.705-2.755-1.545-4.853-2.166-7.586-7.145 1.89-12.84.984-15.804-7.373-1.436-4.05-1.367-8.064-1.178-8.824.087-.349 6.793-2.178 6.793-10.886-2.188.436-6.614 1.6-9.057 1.394-.174-1.394-.262-2.7-.436-4.703-6.242 1.505-4.872-2.229-2.835-5.937l.193-.347.294-.52a89.5 89.5 0 0 1 .098-.17l.197-.342c.917-1.584 1.795-3.037 2.054-3.918C5.598 14.974 6.44.377 10.208.174L9.859 0c6.888.134 8.519 5.728 9.72 11.419z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5vbsk0o6gaW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.499 1.1c7.628-2.717 18.015-.304 23.337 6.182 9.599 11.698 8.488 29.663 3.657 42.497-.926 2.461-3.473 10.693-4.056 11.195-.446.385-7.228-4.286-9.155-6.267-4.484-4.613-8.27-13.704-8.2-14.863.194-3.154 1.07-6.762-.707-9.31-1.307-1.875-4.79-2.961-5.486-2.7-2.822 1.059-3.078 3.283-3.57-.175-.871-6.095-1.94-17.95-9.23-17.33L0 9.809C2.351 5.105 10.429 2.193 13.499 1.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9oqi40jutaX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.642.431 5.325 11.76c-.23 7.624.87 18.724 2.003 26.561.246 1.707.576 3.942.909 6.242l.2 1.384c.71 4.96 1.361 9.79 1.156 9.878-10.625 4.528-15.476-1.078-16.72-7.489-.814-4.196-1.432-7.544-.697-8.012 1.914-1.22 7.325-6.922 6.269-11.727-3.57.261-5.468 1.517-8.708 1.713-.135-1.827-.483-2.79-.349-4.616 5.532-.281 9.623-.813 11.758-5.835C13.239 16.873 13.616 8.186 10.48 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5yldj7dvvaY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.969 0 .004.277c-.07 1.602-.052 2.432-.072 3.72-.062 3.904 5.32 8.58 8.678 9.592 1.017-2.825.748-10.71 3.558-11.633 1.879 3.194.417 6.948 1.27 10.571 2.278 9.681 10.65 13.952 10.478 14.294-1.579 3.152-5.217 4.861-5.979 9.225-7.516-3.93-23.745-10.763-20.329-19.988-2.213-2.206-2.043-4.456.17-6.662C-.553 6.484 1.43 1.834 3.97 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6we9yo1cfaZ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.303 4.415c6.139-2.255 14.135-6.868 20.33-2.79 6.204 4.085 6.762 14.294 3.214 19.976-3.958 6.34-15.107 9.84-21.836 12.54-7.186 2.882-14.349 4.795-21.866 7.345-6.804 2.31-13.002 6.253-19.988 4.1-6.614-2.04-15.13-7.376-21.04-11.148-6.045-3.859-11.116-7.47-17.227-11.06C2.753 22.122-.088 20.514.002 19.03c.275-4.535 3.564-8.806 7.792-10.857l1.024 1.025c-.903-.672 8.144 3.238 17.57 7.348l1.133.493.566.248 1.13.493c8.466 3.695 16.463 7.196 17.015 7.307.976.195 4.792-2.14 8.748-4.644l.66-.419c2.751-1.747 5.498-3.512 7.334-4.505 6.652-3.598 13.28-8.514 20.33-11.104z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vpvrx286vba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.19 1.587c7.77-.754 17.839-2.996 25.28-.282 6.281 2.29 10.254 11.817 11.663 18.626 1.688 8.16 1.834 13.804 1.839 20.631v1.483c-.002 1.002-.004 2.034-.003 3.106.004 4.088.357 16.113.573 28.596l.04 2.394c.208 13.31.227 26.595-.528 30.853-.44 2.484-4.225-.116-5.998 1.433-1.402 1.226-23.962.856-41.421.838h-2.312c-7.59.007-13.922.103-16.638.462.342-13.839.172-24.376.172-37.242 0-12.642-.685-25.113-.685-37.755l-2.05-8.712C-4.62 21.38 6.467 8.88 10.947 6.156c6.683-4.063 13.636-3.83 21.243-4.569z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0zzn6c9smbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.868 0c-.238 3.42-.669 8.806-1.118 14.426l-.081 1.024-.041.513-.082 1.027c-.696 8.734-1.369 17.401-1.369 19.617 0 .26-12.564.432-25.76.571l-1.555.016c-12.19.126-24.52.227-27.651.347C-.407 25.343.467 12.43 1.108 0L2.26.385C4.747.53 8.485.593 12.891.6h1.928C19.185.595 24.08.544 29.002.474L31.216.44C42.28.27 53.081.025 57.868 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "718kqc3qebc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.77 0 2.378 4.613c-.19 5.039-.168 9.85-.157 14.179.014 6.657-.82 4.706-6.834 4.612-.353-6.949-.29-15.976 2.139-22.29C4.489 1.518 4.259.463 4.769 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4oeyhupcbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.513.403.17.304C5.673 4.56 4.403 19.372.046 19.474-.211 13.387.69 5.794.78.058c1.638-.244 3.088.36 4.733.345z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zh2jfo1d6be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.493.513c1.247 3.53 4.759 8.355 6.641 8.45.16.007.577.028.97-.809a.768.768 0 1 1 1.39.655c-.648 1.38-1.591 1.692-2.31 1.692-.043 0-.086 0-.127-.003-3.12-.157-6.875-6.25-8.013-9.474a.768.768 0 1 1 1.45-.511z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "583bgbg9cbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.365.275a.77.77 0 0 1-.095 1.083c-4.711 3.946-2.432 9.056.31 12.648a.768.768 0 1 1-1.222.933C-1.093 9.108-1.12 3.866 3.282.18a.77.77 0 0 1 1.083.096z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8unydsnplbg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.668.239a.77.77 0 0 1-.025 1.087C.15 3.7 2.409 6.936 4.323 9.16l.248.293a.768.768 0 1 1-1.189.973l-.224-.263C-.434 5.989-.965 2.64 1.582.213a.768.768 0 0 1 1.086.026z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l2zucu5ixbh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.322.448c1.63.961 1.784 7.835 1.79 10.05v.415c.62 7.293 5.948 10.67 8.81 12.483.657.416 1.175.744 1.536 1.05a.769.769 0 0 1-.996 1.173c-.278-.237-.781-.555-1.362-.924-3.088-1.956-8.836-5.598-9.523-13.721.02-4.207-.5-8.656-1.071-9.226-.303-.175-.58-.252-.701-.184-.672.371-.753 3.215-.801 4.914-.052 1.825-.097 3.401-.568 4.225a.768.768 0 1 1-1.334-.764C.38 9.45.429 7.78.467 6.434c.08-2.787.154-5.42 1.595-6.216.64-.354 1.4-.276 2.26.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jzkmg65zwbi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.649.119c.36.226.467.7.24 1.06C.356 3.611 4.11 8.835 7.369 11.362c3.208 2.489 5.601 3.614 7.916 4.701l.38.179.756.36c1.76.847 3.503 1.78 5.534 3.381a.768.768 0 1 1-.952 1.207c-2.327-1.834-4.292-2.757-6.372-3.735-2.39-1.123-4.862-2.286-8.204-4.878C3.257 10.117-1.713 4.008.59.36a.768.768 0 0 1 1.06-.24z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6be816osjbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.394.493a.769.769 0 0 1-.442.993c-5.394 2.075-7.036 8.008-7.41 9.778-.079.368-.428.7-.798.7a.573.573 0 0 1-.09-.007c-.404-.06-.688-.453-.65-.859a.791.791 0 0 1 .04-.187C.51 8.787 2.376 2.369 8.4.051a.771.771 0 0 1 .994.442z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uhp288uubbk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01.006c.42.058.715.446.657.867-1.286 9.328-1.241 17.094-.985 23.511 2.31-.348 4.21-.878 6.938-1.639l1.302-.361a.77.77 0 0 1 .971.802c-.444 5.58-3.346 10.605-6.992 12.24.168 4.808 1.415 9.814 3.224 12.878 2.195 3.72 6.412 4.216 13.277 1.56a.768.768 0 1 1 .555 1.434c-1.488.576-4.596 1.778-7.761 1.778-2.77 0-5.585-.92-7.395-3.99-2.031-3.441-3.354-8.867-3.452-14.16a.768.768 0 0 1 .514-.739c3.056-1.074 5.681-5.273 6.373-10.017l-.202.056c-3.113.868-5.17 1.442-7.99 1.798a.765.765 0 0 1-.863-.73C-.106 18.65-.215 10.525 1.143.663a.77.77 0 0 1 .868-.657z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dpelca98tbl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.181 10.068c4.682 6.784 6.003 19.068 4.54 26.56a.77.77 0 0 1-1.51-.294c1.404-7.187.16-18.938-4.296-25.392C34.76-.864 21.708 1.276 16.471 2.745 7.925 5.145 2.898 10.868 1.53 19.758a.768.768 0 1 1-1.52-.234C1.477 9.984 6.877 3.84 16.056 1.265c11.736-3.294 21.985-.084 28.125 8.803z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar43g3mv0bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.812.105c.366.213.49.685.276 1.051-1.433 2.46-2.924 5.087-4.01 7.775-.746 1.847-.546 2.43-.426 2.596.313.428 1.668.329 2.756.251l.69-.047a.768.768 0 1 1 .092 1.535l-.67.046c-.503.036-1.012.073-1.497.073-1.08 0-2.051-.182-2.613-.953-.617-.846-.54-2.141.242-4.076C1.777 5.572 3.298 2.89 4.761.38a.767.767 0 0 1 1.05-.276z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kkq0hg70abn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 0c.443.017.778.326.788.75a49.03 49.03 0 0 0 .095 2.198c.039.634.073 1.183.073 2.256a.769.769 0 0 1-1.538 0c0-1.027-.032-1.547-.07-2.161A51.668 51.668 0 0 1 0 .787.77.77 0 0 1 .75 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gx5gmkiinbo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.116.048c3.812.597 5.225 5.003 5.277 8.595C9.478 14.653 7.068 19 2.78 20.571a.768.768 0 1 1-.53-1.443c4.98-1.825 5.65-7.339 5.606-10.463-.046-3.23-1.295-6.678-3.978-7.098-.757-.12-1.859.074-2.463 1.01a.768.768 0 1 1-1.291-.833C1.127.188 2.9-.141 4.116.048z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "55lw0uenbbp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01.053a.768.768 0 0 1 .44.994c-.222.571-.467 1.166-.712 1.761-.469 1.133-.952 2.304-1.233 3.25a.767.767 0 0 1-.954.519.768.768 0 0 1-.519-.956c.302-1.022.8-2.23 1.285-3.4.24-.584.481-1.168.699-1.729a.767.767 0 0 1 .994-.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09fb1slo1bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.918.014C2.213.271 2.322.297 2.786.56c.17.098.425.243.977.494a.77.77 0 0 1-.64 1.4c-.62-.284-.907-.448-1.1-.558-.255-.146-.255-.146-1.404-.373A.768.768 0 0 1 .918.014z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yx63m2iarbr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.534.698c.127 1.365.879 5.525 1.615 8.258a.77.77 0 0 1-1.485.4C.95 6.707.155 2.46.004.84A.769.769 0 0 1 .696.005a.758.758 0 0 1 .837.693z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dbg45i5g3bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.763.002a.77.77 0 0 1 .72.814C8.07 7.513 5.39 14.463 3.437 19.538c-1.02 2.65-1.985 5.152-1.894 5.947.332 2.89.979 6.052 1.665 9.4.329 1.608.671 3.28 1.002 5.026a.77.77 0 0 1-.757.912.77.77 0 0 1-.755-.626 327.905 327.905 0 0 0-.997-5.005c-.692-3.38-1.346-6.574-1.685-9.531-.129-1.119.592-3.058 1.986-6.676C3.921 14.004 6.55 7.181 6.948.722a.766.766 0 0 1 .815-.72z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kvr63mkgobt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.904 0c.424 0 .769.344.769.768.004 6.653-.286 12.422-.568 18.002-.28 5.54-.568 11.268-.568 17.869a.769.769 0 0 1-1.537 0c0-6.64.289-12.388.57-17.947.28-5.56.57-11.31.565-17.922 0-.426.343-.77.768-.77z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "piq8mqvolbu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.04 0a.77.77 0 0 1 .769.769c0 2.896-.43 9.86-.93 17.208l-.071 1.052c-.193 2.81-.393 5.649-.58 8.315-.28 3.95-.531 7.525-.693 10.063a.767.767 0 0 1-.765.72c-.018 0-.034 0-.05-.003a.767.767 0 0 1-.718-.815c.16-2.541.413-6.119.691-10.073l.288-4.094.073-1.046.073-1.05.073-1.053C1.757 11.925 2.27 3.9 2.27.77c0-.425.345-.769.77-.769z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6gia2mzzdbv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.458 0a.769.769 0 0 1 .758.9.72.72 0 0 1 .008.194c-.015.191-1.832 19.243-3.202 20.042-.486.284-1.275.776-2.191 1.345-5.061 3.149-6.578 3.979-7.288 3.979h-.016c-.137-.003-.208-.004-.754-.245l-.19-.084c-.446-.201-1.142-.526-2.263-1.052C5.8 23.895 2.344 22.273.533 21.617a.768.768 0 0 1-.504-.67c-.017-.248-.027-.71-.029-1.334v-.497C.014 14.029.43 1.113 1.31.238a.86.86 0 0 1 .63-.236c.098.004.626.007 1.456.01H4.48l.246.001h5.894l.351-.001h1.061l.355-.001h.711l.355-.001h.707l.351-.001h.697l.344-.001h.68l.335-.001.979-.001h.933l.3-.001L23.457 0zm-.814 1.538-3.865.004-3.905.004h-.9l-.439.001-.854.001h-.415l-.807.001h-1.151l-.369.001H8.217l-.32.001H4.465L4.26 1.55H3.87l-.182-.001H3.35l-.922-.005c-.43 2.508-1.07 14.506-.89 18.808 1.948.758 5.092 2.234 7.437 3.335 1.111.522 2.255 1.058 2.646 1.22.797-.246 4.424-2.502 6.398-3.731.827-.515 1.552-.965 2.05-1.263.367-1.025 1.17-6.109 1.833-11.471l.096-.786c.253-2.1.48-4.214.647-6.118z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qrbqy9lfvbw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.231.001c.417-.023.791.29.821.713a.769.769 0 0 1-.712.821c-1.823.128-2.66.098-3.469.068-.752-.03-1.53-.056-3.185.042-.033.723-.066 1.408-.099 2.063L2.52 4.98a493.692 493.692 0 0 1-.514 8.055c-.132 1.89-.276 3.969-.44 6.523.869.487 1.578.948 2.266 1.395 1.301.847 2.427 1.579 4.299 2.265a.768.768 0 1 1-.53 1.443c-2.035-.746-3.285-1.56-4.607-2.419-.773-.502-1.572-1.023-2.59-1.568a.769.769 0 0 1-.402-.727c.175-2.782.33-5.006.47-7.018C.746 8.971.963 5.844 1.18.89a.768.768 0 0 1 .713-.733C4.116-.001 5.037.033 5.928.067 6.731.096 7.49.122 9.231 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cw6a94i0qbx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.728 1.094c5.957 1.621 9.255 19.982 10.082 56.133.601 26.294-.434 52.484-.444 52.745a.769.769 0 0 1-.76.739l-60.776.617a.773.773 0 0 1-.777-.768l-.125-70.638c-2.507.848-9.129 3.083-16.005 5.374l-1.117.372-1.117.371c-7.259 2.41-14.337 4.723-16.712 5.376a5.786 5.786 0 0 1-1.541.187C38.094 51.604 9.89 31.85.3 24.512a.77.77 0 0 1 .935-1.222C16.717 35.14 42.79 51.794 49.57 49.934l.167-.046.378-.109c2.775-.81 9.464-3 16.285-5.266l.999-.332.499-.166.997-.332c8.123-2.707 15.775-5.296 16.501-5.541l.054-.018a.767.767 0 0 1 1.014.726l.126 70.932 59.27-.602c1.641-41.757.72-104.084-8.535-106.603-11.609-3.162-39.135 1.75-48.14 4.752-9.293 3.097-40.788 23.228-41.105 23.431a.772.772 0 0 1-.761.04 288.545 288.545 0 0 0-17.257-8.06l-1.008-.431c-1.177-.503-2.358-1.004-3.57-1.517-4.826-2.047-9.817-4.162-16.75-7.367a.769.769 0 0 1 .645-1.396c6.911 3.195 11.89 5.305 16.706 7.347 1.082.459 2.141.908 3.195 1.357l1.052.45c5.082 2.181 10.17 4.461 17.288 8.046C51.372 26.835 79.67 8.88 88.697 5.87c8.686-2.895 36.617-8.154 49.03-4.776z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "phgn56cweby"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.225.908c3.37 1.419 7.772 6.034 8.841 9.546 2.048 6.725 6.253 20.09-1.666 19.444-2.483-.203-4.558 2.003-6.281 4.41l-.284.402c-2.48 3.565-4.202 7.3-5.35 4.156L0 2.736C1.679-.695 6.132-.395 9.225.907z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1l959j72bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.47 0v124.97H0V0h16.47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oup634wo5bA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.038.048c9.838 3.676 12.776 19.217 14.132 30.588 1.16 9.742 2.44 70.177-.514 93.464-.105.833-.651.834-3.279.837-.905.001-2.035.002-3.36.033H8a.769.769 0 0 1-.018-1.537c1.188-.028 2.223-.032 3.08-.033h.313c.715-.001 1.401-.003 1.822-.021 2.857-23.568 1.594-82.931.445-92.56C11.593 13.62 7.294 4.026.5 1.488a.768.768 0 0 1 .539-1.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "opt9d14wvbB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.537.727c.021.371.074.831.127 1.29.057.49.113.983.135 1.38a.77.77 0 0 1-.725.81l-.044.001a.77.77 0 0 1-.766-.725 24.812 24.812 0 0 0-.127-1.29C.08 1.702.023 1.21 0 .813A.77.77 0 0 1 1.537.727z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "py2op07xwbC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.481.003a.769.769 0 0 1 .725.81c-.368 6.549-.796 8.96-1.758 13.279-.369 1.654-1.229 5.526-4.51 6.264a.767.767 0 1 1-.338-1.5c2.053-.462 2.844-2.836 3.346-5.098C4.82 9.843 5.292 7.488 5.67.728c.024-.425.392-.762.811-.725z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apqtij1k8a)",
    transform: "translate(-652 -318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rsakcc2inb)",
    transform: "translate(666.875 324.53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h126.874v234.776H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rv32asy8tc)",
    transform: "translate(700.894 343.492)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFA963",
    d: "M0 0h87.64v193.216H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qoplg3q4ad)",
    transform: "translate(707.655 342.85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v183.35H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#udr0ozs1xe)",
    transform: "translate(707.985 524.152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h75.34v1.537H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svmdz5lkof)",
    transform: "translate(700.884 524.407)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.553v12.803H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1z3jcingag)",
    transform: "translate(652 318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03pxe2qi3h)",
    transform: "translate(43.685 20.112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h98.402v204.49H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5ggasiplgi)",
    transform: "translate(48.298 24.724)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h89.177v194.752H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3iebeootvj)",
    transform: "translate(19.28 217.683)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h30.586v24.856H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y4pr0a4yak)",
    transform: "translate(19.115 5.79)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h31.03v20.569H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el0m55phrl)",
    transform: "translate(18.82 5.762)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v236.119H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diai0n2ukm)",
    transform: "translate(13.85 5.762)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.457v236.778H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xni19miqcn)",
    transform: "translate(141.062 20.093)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h29.358v1.537H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7aaz5yy9co)",
    transform: "translate(140.51 .18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v21.982H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kkjty1tkmp)",
    transform: "translate(43.685 .816)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v21.317H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d61yxph3tq)",
    transform: "translate(140.55 223.577)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v22.208H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3yia9u9o2r)",
    transform: "translate(43.685 223.607)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v21.427H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#le2n0ae8js)",
    transform: "translate(0 20.112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h14.329v1.537H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pqvavdejut)",
    transform: "translate(0 223.577)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h14.329v1.537H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mnu3n3y4du)",
    transform: "translate(39.653)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v20.296H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#773ydkw3mv)",
    transform: "translate(35.36 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v16.718H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ik6apcrj0w)",
    transform: "translate(39.77 224.598)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v21.187H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u18q5trfqx)",
    transform: "translate(35.902 228.133)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v16.883H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eees0gptcy)",
    transform: "translate(129.767 24.85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.537v183.35H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c1pktavcz)",
    transform: "translate(129.275 205.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.074v13.77H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71b4cami9A)",
    transform: "translate(53.166 33.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h80.464v4.484H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zd1u7dl5bB)",
    transform: "translate(52.398 32.712)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h82.002v6.022H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tyvuux4vcC)",
    transform: "translate(60.71 45.872)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h28.084v100.243H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ewx532th0D)",
    transform: "translate(59.942 45.103)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h29.622v101.693H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o6fsrex36E)",
    transform: "translate(100.873 30.841)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.915v17.202H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#psfv0qrmrF)",
    transform: "translate(72.193 45.557)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h29.245v100.32H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de0kffy1tG)",
    transform: "translate(71.425 44.789)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h30.782v101.774H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gy2h9nin3H)",
    transform: "translate(84.493 45.544)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h29.245v100.333H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n1ip8hd79I)",
    transform: "translate(83.725 44.776)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h30.782v101.787H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f4fh5a7xtJ)",
    transform: "translate(113.96 30.941)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.897v17.614H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k7klywjzxK)",
    transform: "translate(97.563 45.643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90BEB2",
    d: "M0 0h29.245v100.332H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#etgy3lbylL)",
    transform: "translate(96.794 44.877)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h30.782v101.784H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y8yzhinefM)",
    transform: "translate(76.033 30.717)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.812v15.632H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7g22d2lleN)",
    transform: "translate(88.665 30.84)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.823v15.58H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aahl2bv5tO)",
    transform: "translate(85.65 150.7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h44.338v24.72H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wpxixkbbpP)",
    transform: "translate(93.285 159.687)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h38.135v55.291H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fqy9ovlhhQ)",
    transform: "translate(54.714 150.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h58.074v64.93H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ryk9devlbR)",
    transform: "translate(87.48 149.725)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h42.629v3.817H-.001V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hxt7kgxthS)",
    transform: "translate(80.487 155.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h27.853v8.446H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m5ror0ohbT)",
    transform: "translate(54.075 152.111)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.235v64.006H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hi5b10i40U)",
    transform: "translate(54.36 151.711)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h77.877v64.555H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1oij8ly1hV)",
    transform: "translate(57.895 149.813)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h31.827v3.84H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fpevrv2dW)",
    transform: "translate(58.355 176.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h39.127v14.856H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jzzbj6nptX)",
    transform: "translate(57.281 187.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h44.558v15.444H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qov65gyzkY)",
    transform: "translate(56.62 197.294)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h49.138v15.61H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kt4a4swruZ)",
    transform: "translate(91.543 169.963)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h34.295v13.994H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1pi0m8bmaa)",
    transform: "translate(97.862 176.981)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h23.46v1.897H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lsj0mfj6hab)",
    transform: "translate(99.839 180.577)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h28.85v10.344H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6xoayb3v1ac)",
    transform: "translate(100.857 194.89)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h27.249v1.764H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bec424drzad)",
    transform: "translate(103.672 199.883)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h24.748v1.833H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wlcl82zilae)",
    transform: "translate(104.353 200.252)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h25.48v7.134H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gv946uko1af)",
    transform: "translate(104.01 210.242)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h24.59v1.62H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g6cr7yxw7ag)",
    transform: "translate(79.449 170.898)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h15.025v10.81H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aduxxvz90ah)",
    transform: "translate(73.35 168.151)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h12.56v6.577H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mybpzf23zai)",
    transform: "translate(61.991 173.925)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.422v8.71H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pbempasb6aj)",
    transform: "translate(65.826 166.412)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.559v8.586H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o2rvc2l5sak)",
    transform: "translate(710.276 511.715)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e2ekblkjpal)",
    transform: "translate(0 .452)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    d: "M0 0h7.883v18.355H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vbhpatb4gam)",
    transform: "translate(728.78 511.861)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    d: "M0 0h7.803v18.406H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8hjyjjpslan)",
    transform: "translate(737.195 511.772)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    d: "M0 0h5.881v18.381H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l8hhd1rn2ao)",
    transform: "translate(710.367 511.714)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mbrxcdf49ap)",
    transform: "translate(8.62 .344)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    d: "M0 0h9.22v18.3H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ws733peltaq)",
    transform: "translate(710.367 511.714)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zb80hq1xhar)",
    transform: "translate(33.726 15.129)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h3.234v3.235H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#22haw50baas)",
    transform: "translate(779.116 523.918)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.34v6.285H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o45c9rg8nat)",
    transform: "translate(777.896 507.619)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.154v6.801H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n8c2p1zu2au)",
    transform: "translate(778.685 513.022)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.584v6.669H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nsckvpvyyav)",
    transform: "translate(728.306 491.476)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E05A31",
    d: "M0 0h9.345v7.774H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qqpb5dx73aw)",
    transform: "translate(721.651 491.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.642v10.064H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47xxi7h44ax)",
    transform: "translate(706.465 528.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.874v5.13H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xado5yl24ay)",
    transform: "translate(780.138 527.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.053v4.773H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#otskxoof3az)",
    transform: "translate(776.365 470.196)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h5.139v27.053H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#169ig0emeaA)",
    transform: "translate(709.878 470.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.289v26.754H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kopiso6nraB)",
    transform: "translate(721.598 501.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h13.635v15.723H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saf9iuoysaC)",
    transform: "translate(720.83 501.077)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h15.17v17.26H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5nktqjvpaD)",
    transform: "translate(730.933 407.55)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h13.633v15.723H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2bdo0ys7iaE)",
    transform: "translate(730.165 406.782)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h15.17v17.26H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#we7z7ozukaF)",
    transform: "translate(720.814 393.061)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h10.24v11.808H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hyfof54ttaG)",
    transform: "translate(720.047 392.294)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.776v13.344H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7dsrv0xxyaH)",
    transform: "translate(727.737 485.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h10.24v11.808H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clx4x85v8aI)",
    transform: "translate(726.97 485.228)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h11.776v13.344H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xjqrw9iplaJ)",
    transform: "translate(714.535 414.218)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h12.16v23.437H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tdhj8n1w9aK)",
    transform: "translate(713.766 413.449)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h13.697v24.976H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#saptvqeuqaL)",
    transform: "translate(756.502 373.132)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h6.15v26.48H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#swr79n6bqaM)",
    transform: "translate(742.404 371.424)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h7.265v27.931H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ubi8unl5naN)",
    transform: "translate(730.333 371.595)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h6.865v25.455H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o6g8av41maO)",
    transform: "translate(719.088 371.425)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h5.638v9.395H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crsr4pvx1aP)",
    transform: "translate(717.258 383.069)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h2.221v15.347H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lg9pbwu0yaQ)",
    transform: "translate(703.95 363.993)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h19.205v36.182H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rs88gvngmaR)",
    transform: "translate(703.18 363.223)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h20.743v37.72H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v05jtcp0gaS)",
    transform: "translate(705.698 470.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h20.57v36.182H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz7lz27qeaT)",
    transform: "translate(704.93 469.32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h22.107v37.722H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rec80p8miaU)",
    transform: "translate(729.052 476.746)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M0 0h20.275v8.902H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no6y4hae4aV)",
    transform: "translate(762.718 355.687)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h48.185v67.885H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5vbsk0o6gaW)",
    transform: "translate(772.142 346.315)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h44.118v60.996H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9oqi40jutaX)",
    transform: "translate(767.41 359.257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#906B41",
    d: "M0 0h20.273v57.898H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5yldj7dvvaY)",
    transform: "translate(662.076 407.215)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h27.888v36.046H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6we9yo1cfaZ)",
    transform: "translate(683.877 425.52)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h109.035v46.209H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vpvrx286vba)",
    transform: "translate(763.861 422.027)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h71.706v109.727H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0zzn6c9smbb)",
    transform: "translate(770.898 531.199)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#635A59",
    d: "M0 0h57.868v37.541H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#718kqc3qebc)",
    transform: "translate(827.84 522.87)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h7.148v23.741H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4oeyhupcbd)",
    transform: "translate(826.756 546.448)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF497",
    d: "M0 0h5.683v19.474H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zh2jfo1d6be)",
    transform: "translate(665.47 410.89)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.569v10.501H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#583bgbg9cbf)",
    transform: "translate(662.557 406.324)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.738v15.241H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8unydsnplbg)",
    transform: "translate(661.553 416.032)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.745v10.709H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l2zucu5ixbh)",
    transform: "translate(674.556 408.917)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.728v25.801H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jzkmg65zwbi)",
    transform: "translate(662.057 422.748)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h22.247v21.355H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6be816osjbj)",
    transform: "translate(682.77 432.877)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h9.445v11.964H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uhp288uubbk)",
    transform: "translate(766.683 364.924)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h21.448v53.076H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dpelca98tbl)",
    transform: "translate(767.82 345.84)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h49.288v37.25H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar43g3mv0bm)",
    transform: "translate(762.091 373.122)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h6.193v13.385H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kkq0hg70abn)",
    transform: "translate(769.265 374.538)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.706v5.973H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gx5gmkiinbo)",
    transform: "translate(782.858 373.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h9.395v20.618H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55lw0uenbbp)",
    transform: "translate(784.436 379.657)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.502v6.608H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09fb1slo1bq)",
    transform: "translate(769.485 359.466)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h4.212v2.522H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yx63m2iarbr)",
    transform: "translate(786.702 414.687)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.176v9.925H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dbg45i5g3bs)",
    transform: "translate(808.073 381.552)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h8.485v40.823H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kvr63mkgobt)",
    transform: "translate(770.174 531.593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h2.673v37.407H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#piq8mqvolbu)",
    transform: "translate(825.28 530.597)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h3.809v38.127H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6gia2mzzdbv)",
    transform: "translate(785.922 536.238)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h24.227v26.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qrbqy9lfvbw)",
    transform: "translate(818.467 535.954)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h10.054v24.71H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cw6a94i0qbx)",
    transform: "translate(682.829 421.069)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h147.998v111.328H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phgn56cweby)",
    transform: "translate(812.365 423.368)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8D3F",
    d: "M0 0h21.028v40.047H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1l959j72bz)",
    transform: "translate(820.253 422.443)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oup634wo5bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h16.47v124.97H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#opt9d14wvbB)",
    transform: "translate(827.677 450.327)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h1.8v4.208H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#py2op07xwbC)",
    transform: "translate(826.033 546.113)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1918",
    d: "M0 0h7.207v20.375H0V0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManOpenLocker);
export default __webpack_public_path__ + "static/media/man_open_locker.f65ff8469fddd94555514855bb409688.svg";
export { ForwardRef as ReactComponent };